import { render, staticRenderFns } from "./SalidaVehiculo.vue?vue&type=template&id=280a255f"
import script from "./SalidaVehiculo.vue?vue&type=script&lang=js"
export * from "./SalidaVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports